import { createContext } from "react";

export const storeContext = createContext(null);
